"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Button = void 0;
const vue_1 = require("vue");
exports.Button = vue_1.default.component('Button', {
    props: {
        title: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        align: {
            type: String,
            validator: (align) => ['right', 'left'].includes(align),
        },
        size: {
            type: String,
            default: 'normal',
            validator: (item) => ['tiny', 'small', 'normal', 'big', 'jumbo'].includes(item),
        },
        disableOnServerBusy: {
            type: Boolean,
            default: true,
        },
        type: {
            type: String,
            default: 'normal',
            validator: (item) => [
                'normal',
                'action',
                'max',
                'success',
                'error',
                'submit',
                'close',
                'back',
                'minus',
                'plus',
            ].includes(item),
        },
        onClick: {
            type: Function,
            default: () => { },
        },
    },
    methods: {
        getOuterClass: function () {
            const classes = ['btn'];
            if (this.size === 'tiny') {
                classes.push('btn-tiny');
            }
            else if (this.size === 'small') {
                classes.push('btn-sm');
            }
            else if (this.size === 'big') {
                classes.push('btn-lg');
            }
            if (this.type === 'max') {
                classes.push('btn-max');
            }
            else if (this.type === 'success') {
                classes.push('btn-success');
            }
            else if (this.type === 'error') {
                classes.push('btn-error');
            }
            else if (this.type === 'action') {
                classes.push('btn-action');
            }
            else if (this.type === 'submit') {
                classes.push('btn-submit');
                if (this.title === 'Concede')
                    classes.push('btn-submit-warning');
            }
            if (this.align === 'left') {
                classes.push('float-left');
            }
            else if (this.align === 'right') {
                classes.push('float-right');
            }
            if (this.disableOnServerBusy) {
                if (this.$root.isServerSideRequestInProgress) {
                    classes.push('loading');
                }
            }
            return classes.join(' ');
        },
        getDisabled: function () {
            if (this.disableOnServerBusy) {
                return (this.disabled ||
                    this.$root.isServerSideRequestInProgress);
            }
            return this.disabled;
        },
        getInnerClass: function () {
            switch (this.type) {
                case 'close':
                    return 'icon icon-cross';
                case 'back':
                    return 'icon icon-back';
                case 'plus':
                    return 'icon icon-plus';
                case 'minus':
                    return 'icon icon-minus';
            }
            return '';
        },
    },
    template: `
        <button v-on:click.prevent="onClick" :class="getOuterClass()" :disabled="getDisabled()" v-i18n>
          <span v-if="getInnerClass() !== ''" :class="getInnerClass()"></span>
          <span v-else>{{this.title}}</span>
        </button>
    `,
});
//# sourceMappingURL=Button.js.map